import Vue from "vue";
import YmapPlugin from "vue-yandex-maps";
import App from "./App.vue";
import VueScrollTo from "vue-scrollto";
import axios from "axios";
import VueAxios from "vue-axios";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
//import { loadYmap } from "vue-yandex-maps";
//import router from "./router";

const mapSettings = {
  apiKey: "e3f82583-d33b-41a3-a92f-326a954b7480",
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1"
};

Vue.use(YmapPlugin, mapSettings);
Vue.use(VueScrollTo);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  i18n,

  //router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount("#app");
